import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import Select2 from 'react-select2-wrapper';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import withUser from '../../common/withUser';
import withOnline from '../../common/withOnline';
import { onGoBack, sortData } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';
import {
  deleteByPrimaryKey,
  getHospitals,
  getInventory,
  getInventoryByAccountName,
  getInventoryByID,
  getInventoryBySessionID,
  getTeamReps,
  updateInventoryByInventoryId,
  updateInventoryByLocalInventoryId
} from '../../utils/db';
import withSingleScanSession from '../../common/withSingleScanSession';
import DeleteManageSessionsModal from '../../components/Models/DeleteManageSessionsModal';
import {
  saveScanInventoryData,
  submitScanData
} from '../../utils/utils';

class ManageSessions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account: [],
      selectedAccountName: '',
      scanSessionData: {},
      singleSessionData: [],
      session: [],
      selectedIds: [],
      isSubmitted: true,
      unSubmittedProductCount: 0
    };
    this.deleteManageSessionsModal = null;
  }

  componentDidMount() {
    this.deleteManageSessionsModal = new window.bootstrap.Modal(window.$('#deleteManageSessionsModal'));
  }

  _onSingleSessionData = async (data) => {
    try {
      const {
        SessionID, SessionName, sessionNameWithId, productCount
      } = data;
      const { setSingleScanSession, singleScanSession } = this.props;
      setSingleScanSession({
        ...singleScanSession, SessionID, SessionName, sessionNameWithId, productCount
      });
      this._onGoBack();
      browserHistory.push('/inventory/consignment/scan-session/edit-session');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetAccountName = async () => {
    try {
      const { user } = this.props;
      const hospitalRes = await getHospitals();
      const sortHospital = sortData(hospitalRes, 'CustomerName');
      const repRes = await getTeamReps();
      const sortRep = sortData(repRes, 'SalesRepName');
      const teamRes = user.selectedTeam;
      teamRes.AccountNameAndNumber = user.selectedTeam.name;
      teamRes.AccountName = user.selectedTeam.name;
      teamRes.AccountNo = '';
      teamRes.AccountAbb = user.selectedTeam.name.split(' ').map((x) => x[0]).join('');
      const teamArr = [];
      teamArr.push(teamRes);
      sortHospital.map((value) => {
        value.AccountNameAndNumber = `${value.CustomerName} (${(Number(value.CustomerNo).toString())})`;
        value.AccountName = value.CustomerName;
        value.AccountNo = (Number(value.CustomerNo).toString());
        value.AccountAbb = value.CustomerAbb;
      });
      sortRep.map((value) => {
        value.AccountNameAndNumber = `${value.SalesRepName} (${((value.SalesRepNo !== '' && value.SalesRepNo !== null)
          ? Number(value.SalesRepNo).toString() : '')})`;
        value.AccountName = value.SalesRepName;
        value.AccountNo = Number(value.SalesRepNo).toString();
        value.AccountAbb = value.SalesRepName.substr(0, value.SalesRepName.indexOf(','));
      });
      const merged = _(teamArr)
        .concat(sortRep, sortHospital)
        .groupBy('AccountName')
        .map(_.spread(_.merge))
        .value();
      const getInventoryScan = await getInventory();
      const onlySessionData = [];
      merged.map(async (value) => {
        getInventoryScan.map((item) => {
          if (value.AccountName === item.AccountName) {
            onlySessionData.push(value);
          }
        });
      });
      // Creates an array of objects with unique "AccountName" property values.
      const uniqueObjArray = [
        ...new Map(onlySessionData.map((item) => [item.AccountName, item])).values(),
      ];
      this.setState({
        account: uniqueObjArray
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectAll = (isSelected) => {
    try {
      const { scanSessionData } = this.state;
      let selectedIds = [];
      if (isSelected === false) {
        Object.keys(scanSessionData).map((session) => {
          scanSessionData[session].map(({ SessionID }) => {
            selectedIds.push(SessionID);
          });
        });
      } else {
        selectedIds = [];
      }
      this.setState({ selectedIds }, () => {
        this._onGetInventorySession(selectedIds);
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectedIds = (userId) => {
    try {
      const { selectedIds } = this.state;
      if (selectedIds.indexOf(userId) > -1) {
        selectedIds.splice(selectedIds.indexOf(userId), 1);
      } else {
        selectedIds.push(userId);
      }
      this.setState({ selectedIds }, () => {
        this._onGetInventorySession(selectedIds);
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _goBack = () => {
    try {
      const { goBack, setSingleScanSession } = this.props;
      setSingleScanSession({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  countProduct = (productRes) => {
    const productData = {};
    productRes.forEach(async (product) => {
      const key = `${product.SessionID}`;
      if (!productData[key]) {
        productData[key] = { ...product, productCount: 0 };
      }
      productData[key].productCount += 1;
    });
    return Object.values(productData);
  };

  _getInventoryByAccountName = async (accountName) => {
    try {
      const { selectedIds } = this.state;
      if (accountName !== undefined) {
        if (accountName.length > 0) {
          const getInventoryByAccountNameRes
            = await getInventoryByAccountName(accountName);
          const scanSessionRes = getInventoryByAccountNameRes.reduce((session, value) => {
            const key = value.SessionID;
            if (session[key] == null) session[key] = [];
            value.sessionNameWithId = value.SessionName === '' ? value.SessionID
              : `${value.SessionName}(${value.SessionID})`;
            session[key].push({
              sessionNameWithId: value.sessionNameWithId,
              SessionName: value.SessionName,
              SessionID: value.SessionID,
              Submitted: value.Submitted,
              id: value.inventoryId
            });
            return session;
          }, {});
          Object.keys(scanSessionRes).map((data) => {
            const maxValue = scanSessionRes[data].map((o) => o.Submitted);
            scanSessionRes[data].map((value) => {
              value.SubmitedValue = maxValue.every((item) => item === 1);
              value.productCount = scanSessionRes[data].length;
            });
          });
          const uniqueValue = {};
          Object.keys(scanSessionRes).map((key) => {
            Object.assign(uniqueValue, {
              [key]: [...new Map(scanSessionRes[key]
                .map((item) => [item.SessionID, item])).values()]
            });
          });
          this.setState({
            scanSessionData: uniqueValue
          });
          this._onGetInventorySession(selectedIds);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeAccount = async (key) => {
    try {
      const { account } = this.state;
      const { setSingleScanSession, singleScanSession } = this.props;
      if (account[key] !== undefined) {
        const {
          AccountName, AccountNameAndNumber
        } = account[key];
        setSingleScanSession({ ...singleScanSession, AccountName: AccountNameAndNumber });
        this.setState({ selectedAccountName: key });
        await this._getInventoryByAccountName(AccountName);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedSubmit = async () => {
    try {
      const {
        online, notify, setLoader, singleScanSession
      } = this.props;
      const { selectedIds } = this.state;
      selectedIds.map(async (selectedId) => {
        const inventoryRes = await getInventoryBySessionID(selectedId);
        if (online) {
          const scanInventoryID = [];
          let responseJson = {};
          let submitResponseJson = {};
          setLoader(true);
          const hospitalPromiseAll = inventoryRes.map(async (data) => new Promise(
            // eslint-disable-next-line no-async-promise-executor
            async (resolve) => {
              if (data.ID === null) {
                responseJson = await saveScanInventoryData(data);
                const { message, status, ID } = responseJson;
                if (status) {
                  data.ID = ID;
                  await updateInventoryByLocalInventoryId(data.inventoryId, data);
                  scanInventoryID.push(ID);
                } else {
                  notify({ type: 'error', message, time: 3 });
                }
              } else {
                scanInventoryID.push(data.ID);
              }
              resolve(true);
            }
          ));
          setLoader(false);
          await Promise.all(hospitalPromiseAll);
          setLoader(true);
          if (scanInventoryID.length > 0) {
            submitResponseJson = await submitScanData({ ID: scanInventoryID });
            if (submitResponseJson.hasOwnProperty('failed_IDs')) {
              const { failed_IDs } = submitResponseJson;
              scanInventoryID.map(async (id) => {
                const getInventoryResById = await getInventoryByID(id);
                if (failed_IDs.includes(id) === true) {
                  getInventoryResById.Submitted = 0;
                  await updateInventoryByInventoryId(id, getInventoryResById);
                } else {
                  getInventoryResById.Submitted = 1;
                  await updateInventoryByInventoryId(id, getInventoryResById);
                }
              });
            } else {
              scanInventoryID.map(async (id) => {
                const getInventoryResById = await getInventoryByID(id);
                getInventoryResById.Submitted = 1;
                await updateInventoryByInventoryId(id, getInventoryResById);
              });
            }
          }
          setTimeout(async () => {
            await this._getInventoryByAccountName(singleScanSession.AccountName);
          }, 1000);
          setLoader(false);
        } else {
          notify({
            type: 'error',
            message: 'You must have as internet connection. Please check your connection and try again.',
            time: 3
          });
        }
      });
      this._onGetInventorySession(selectedIds);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenSessionDeletePopup = (data) => {
    try {
      this.setState({ selectedIds: data });
      this.deleteManageSessionsModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedDelete = async (data) => {
    try {
      const { setLoader, singleScanSession } = this.props;
      const arrDelete = [];
      // eslint-disable-next-line no-async-promise-executor
      const deleteDataPromiseAll = data.map(async (id) => new Promise(async (resolve) => {
        arrDelete.push(await getInventoryBySessionID(id));
        resolve(true);
      }));
      await Promise.all(deleteDataPromiseAll);
      arrDelete.map((value) => {
        value.map(async (item) => {
          if (item.inventoryId !== undefined) {
            setLoader(true);
            await deleteByPrimaryKey(item.inventoryId);
            await this._getInventoryByAccountName(singleScanSession.AccountName);
            this.setState({ selectedIds: [] });
            setLoader(false);
          }
        });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetInventorySession = (selectedIds) => {
    const { scanSessionData } = this.state;
    const selectedInventoryData = [];
    selectedIds.map((value) => {
      selectedInventoryData.push(scanSessionData[value][0]);
    });
    const isFound = selectedInventoryData.find((o) => o.Submitted === 0);
    if (selectedInventoryData.length > 0) {
      if (isFound !== undefined) {
        this.setState({
          isSubmitted: false
        });
      } else {
        this.setState({
          isSubmitted: true
        });
      }
    } else {
      this.setState({
        isSubmitted: true
      });
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { singleScanSession } = this.props;
      await this._onGetAccountName();
      await this._getInventoryByAccountName(singleScanSession.AccountName);
      this._onGetInventorySession();
      const { account } = this.state;
      if (singleScanSession !== undefined) {
        this.setState({
          selectedAccountName: account.findIndex(
            (x) => x.AccountName === singleScanSession.AccountName
          ),
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      account, selectedAccountName, scanSessionData, selectedIds,
      isSubmitted
    } = this.state;
    return (
      <section className="list-section resizer-class">
        <Header
          title="Manage Sessions"
          goBack={this._goBack}
        />
        <section className="case-details-section pb-5 manage-session">
          <div className="container">
            <div className="row gx-2">
              <div className="col-12 col-md-12">
                <div className="case-data">
                  <label htmlFor="account">Account</label>
                  <Select2
                    className="form-control select-2-black rounded"
                    style={{ width: '100%' }}
                    onSelect={({ target: { value } }) => {
                      this._onChangeAccount(value);
                    }}
                    data={account.map((value, key) => (
                      { id: key, text: value.AccountNameAndNumber }))}
                    value={selectedAccountName}
                    options={{ placeholder: 'Select Account' }}
                  />
                </div>
              </div>
              <div className="col-6 mt-3 mb-3">
                <label htmlFor="scan">Scan Sessions</label>
              </div>
              <div className="col-6">
                <Link
                  type="checkbox"
                  className="btn btn-theme-alt btn-theme-outline-alt d-block"
                  onClick={() => this._onSelectAll(
                    selectedIds.length === Object.keys(scanSessionData).length
                  )}
                  checked={selectedIds.length === Object.keys(scanSessionData).length
                    && Object.keys(scanSessionData).length > 0}
                  id="selectedAll"
                  readOnly
                  disabled={Object.keys(scanSessionData).length === 0}
                >{(selectedIds.length === Object.keys(scanSessionData).length
                  && (selectedAccountName !== -1 && Object.keys(scanSessionData).length > 0))
                  ? 'Deselect All' : 'Select All'}
                </Link>
              </div>

              <hr className="line-height" />
              {
                !_.isEmpty(scanSessionData) && Object.keys(scanSessionData).map((session) => (
                  scanSessionData[session].map((item, key) => (
                    <div className="col-12 mb-3 ms-wrap ss-group-block-bottom" key={key}>
                      <div className="row gx-2">
                        <div className="col-auto align-self-center">
                          <label className="cursor-pointer mt-2">
                            <input
                              type="checkbox" onClick={() => this._onSelectedIds(item.SessionID)}
                              checked={selectedIds.indexOf(item.SessionID) > -1}
                              data-checkboxes="mygroup"
                              id={item.id}
                              readOnly
                            />
                            <span />
                          </label>
                        </div>
                        <div className="col-auto align-self-center session-block">
                          <p className="time m-0">
                            <span className={`status ${item.SubmitedValue === false ? 'red' : 'green'}`} />
                          </p>
                        </div>
                        <div className="col align-self-center">
                          <span>
                            {item.SessionName} {item.SessionName !== '' ? '<br />' : ''} {item.SessionID}
                          </span>
                        </div>
                        <div className="col-auto align-self-center">
                          <span>({item.productCount})</span>
                          <Link className="btn-over-link" onClick={() => this._onSingleSessionData(item)} />
                        </div>
                      </div>
                    </div>
                  ))
                ))
              }
              <div className="col-12 sets-footer-section fixed-bottom resizer-class">
                <div className="row gx-2">
                  <div className="col-6 col-md-6">
                    <button
                      onClick={this._onSelectedSubmit}
                      disabled={(selectedIds.length === 0 || (isSubmitted === true))}
                      className={`${isSubmitted ? 'btn btn-theme-alt btn-theme-outline-alt' : 'btn btn-red'} d-block w-100`}
                    >Submit Selected
                    </button>
                  </div>
                  <div className="col-6 col-md-6">
                    <button
                      className="btn btn-theme-alt btn-theme-outline-alt d-block w-100"
                      onClick={() => this._onOpenSessionDeletePopup(selectedIds)}
                      disabled={selectedIds.length === 0}
                    >Delete Selected
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DeleteManageSessionsModal
            sessionData={selectedIds}
            onClickYes={this._onSelectedDelete}
          />
        </section>
      </section>
    );
  }
}

export default withOnline(
  withSingleScanSession(
    withUser(
      withGoBack(
        withNotify(
          withLoader(
            ManageSessions
          )
        )
      )
    )
  )
);
